// Ported from EnterpriseTemplates react-project-template (Release 1.3.1), PMS slice 4b.
// ============================================================================
// ORG ADMIN HOOKS
// ============================================================================
// Server-side paged list of one organisation kind. Re-fetches when the query
// changes.

import { useState, useEffect, useCallback } from 'react';
import { organisationService } from 'api/services/organisationService';
import type { PaginationMeta } from 'api/types';
import type { OrganisationKind, OrganisationListParams } from 'api/types/organisation.types';

const EMPTY_PAGINATION: PaginationMeta = {
  currentPage: 1, pageSize: 25, totalPages: 0, totalItems: 0, hasNextPage: false, hasPreviousPage: false,
};

export const useOrganisationList = <T,>(kind: OrganisationKind, params: OrganisationListParams) => {
  const [data, setData] = useState<T[]>([]);
  const [pagination, setPagination] = useState<PaginationMeta>(EMPTY_PAGINATION);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const paramsKey = JSON.stringify(params);

  const fetchPage = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await organisationService.list<T>(kind, params);
      setData(response.data);
      setPagination(response.pagination);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind, paramsKey]);

  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  return { data, pagination, loading, error, refetch: fetchPage };
};
